<template>
  <div class="mine">
  <p>{{list}}</p>
  <!--  -->
  </div>
</template>

<script>

import axios from "axios"

export default {
  name:'mine',
  data(){
    return{
      list:"hallo word"
    }
  },
  // beforeRouteLeave(to,from,next){
  //   console.log(to.name)
  //   let arr = ['storelist','selfList','goodsList','orderlist','customerlist']
  //   if(!arr.includes(to.name)){
  //     this.$store.state.enterWeimeng=false
  //   }
  //   // ||to.name!='selfList'
  //   next()
  // },
}
</script>
<style lang>

</style>
